module.exports = __webpack_public_path__ + "static/img/3.7b1399f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/eng/3.png
// module id = /pPd
// module chunks = 0